import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import API from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('plush_token');
    const saved = localStorage.getItem('plush_user');
    if (token && saved) {
      try {
        setUser(JSON.parse(saved));
      } catch { localStorage.removeItem('plush_user'); }
    }
    setLoading(false);
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await API.post('/auth/login', { email, password });
    localStorage.setItem('plush_token', data.token);
    localStorage.setItem('plush_user', JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  }, []);

  const register = useCallback(async (userData) => {
    const { data } = await API.post('/auth/register', userData);
    localStorage.setItem('plush_token', data.token);
    localStorage.setItem('plush_user', JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('plush_token');
    localStorage.removeItem('plush_user');
    setUser(null);
  }, []);

  const updateUser = useCallback((updated) => {
    localStorage.setItem('plush_user', JSON.stringify(updated));
    setUser(updated);
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, updateUser, isAdmin: user?.role === 'admin' || user?.role === 'super_admin', isGuest: user?.role === 'guest' }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
